import SubActivityView from '../../sub-activity/sub-activity-view';
import { useStudentGetAnswers } from 'approot/activity-builder/student/answer/student-answer.hooks';
import { useBatchStudentAnswersContext } from '../../shared/batch-student-answer.context';
import ComponentLoading from '../../shared/component-loading';
import { ViewProps } from '../fill-in-blanks.constants';
import FillInBlanksViewContent from '../fill-in-blanks-view-content';
import FillInBlanksPreview from '../fill-in-blanks-preview';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import { AnswerSaveStatus } from '../../shared/answer-save-status/answer-save-status';

const FillInBlanksStudent = (
  props: ViewProps & {
    isLoggedIn: boolean;
  }
) => {
  const { id, type, subActivityProperties, isLoggedIn } = props;

  const { componentAnswers, variables, hasFetchedAnswers, error } =
    useStudentGetAnswers({
      componentId: id,
    });

  const { handleUpdate } = useBatchStudentAnswersContext();
  const { activeComponent, setActiveComponent } =
    useActivityBuilderPresentContext();

  return isLoggedIn ? (
    <SubActivityView
      componentId={id}
      componentType={type}
      subActivityDetails={subActivityProperties}
      onClick={() => setActiveComponent({ id })}
    >
      {activeComponent?.id === id && <AnswerSaveStatus />}
      <FillInBlanksViewContent
        {...props}
        componentAnswers={componentAnswers}
        updateAnswer={input => {
          if (variables) {
            handleUpdate({
              input,
              variables,
            });
          }
        }}
        onFocus={() => setActiveComponent({ id })}
      />
      <ComponentLoading hasData={hasFetchedAnswers} error={error} />
    </SubActivityView>
  ) : (
    <FillInBlanksPreview {...props} />
  );
};

export default FillInBlanksStudent;
